import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { generateRoutePath } from '@/src/routes';

import { entryActionCustomValidateOptions } from './inbox';

import { InboxEntryStatus, UpdateFileEntryResponse } from '../types';

const url = `${PREFIX_URL}/inbox-documents/:fileId`;

export type UpdateFileStatusDTO = {
  fileId: number;
  status: InboxEntryStatus;
};

export const updateWebAppFileStatus = ({
  fileId,
  status,
}: UpdateFileStatusDTO): Promise<UpdateFileEntryResponse> => {
  return axios.put(
    generateRoutePath(url, { fileId }),
    { status },
    {
      ...entryActionCustomValidateOptions,
    }
  );
};
